import {useEffect, useState} from "react";
import axios from "axios";
import {
    API_APARTMENT_SEARCH_VERSION,
    API_BOOKING_GATEWAY_VERSION,
    API_CONSENT_MANAGEMENT_VERSION,
    API_CUSTOMER_DOCUMENTS_VERSION,
    API_CUSTOMER_PRODUCTS_VERSION,
    API_CUSTOMER_PRODUCTS_VERSION_LEGACY,
    API_PAYMENTS_VERSION,
    API_SHARE_MARKETPLACE_VERSION,
    API_SHARE_MARKETPLACE_VERSION_LEGACY,
    API_USER_ACCOUNTS_VERSION,
    apartmentSearchAPI,
    bookingAPI,
    consentManagementAPI,
    customerProductsAPI,
    documentsAPI,
    paymentsAPI,
    shareMarketplaceAPI,
    userAccountsAPI,
} from "../common/api";
import {useKeycloakFunctions} from "./useKeycloakFunctions";

export const useVersions = () => {
    const VERSION = "/version";

    const [apartmentSearch, setApartmentSearch] = useState({});
    const [bookingGateway, setBookingGateway] = useState({});
    const [consentManagement, setConsentManagement] = useState({});
    const [customerProducts, setCustomerProducts] = useState({});
    const [customerDocuments, setCustomerDocuments] = useState({});
    const [payments, setPayments] = useState({});
    const [marketplace, setMarketplace] = useState({});
    const [userAccounts, setUserAccounts] = useState({});

    const {keycloak} = useKeycloakFunctions();

    axios.interceptors.request.use((config) => {
        if (keycloak) {
            const token = keycloak.token || undefined;

            if (token) {
                keycloak.updateToken(process.env.KEYCLOAK_TOKEN_MIN_VALIDITY);
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        config.metadata = { startTime: new Date()};

        return config;
    }, (err) => Promise.reject(err));


    useEffect(() => {
        axios.get(apartmentSearchAPI.defaults.baseURL.replace(API_APARTMENT_SEARCH_VERSION, VERSION))
            .then(response => {
                setApartmentSearch(response.data);
            })
            .catch(function (error) {
                console.error(error);
            });

        axios.get(bookingAPI.defaults.baseURL.replace(API_BOOKING_GATEWAY_VERSION, VERSION))
            .then(response => {
                setBookingGateway(response.data);
            })
            .catch(function (error) {
                console.error(error);
            });

        axios.get(consentManagementAPI.defaults.baseURL.replace(API_CONSENT_MANAGEMENT_VERSION, VERSION))
            .then(response => {
                setConsentManagement(response.data);
            })
            .catch(function (error) {
                console.error(error);
            });

        axios.get(customerProductsAPI.defaults.baseURL.replace(API_CUSTOMER_PRODUCTS_VERSION_LEGACY, VERSION).replace(API_CUSTOMER_PRODUCTS_VERSION, VERSION))
            .then(response => {
                setCustomerProducts(response.data);
            })
            .catch(function (error) {
                console.error(error);
            });

        axios.get(documentsAPI.defaults.baseURL.replace(API_CUSTOMER_DOCUMENTS_VERSION, VERSION))
            .then(response => {
                setCustomerDocuments(response.data);
            })
            .catch(function (error) {
                console.error(error);
            });

        axios.get(paymentsAPI.defaults.baseURL.replace(API_PAYMENTS_VERSION, VERSION))
            .then(response => {
                setPayments(response.data);
            })
            .catch(function (error) {
                console.error(error);
            });

        axios.get(shareMarketplaceAPI.defaults.baseURL.replace(API_SHARE_MARKETPLACE_VERSION_LEGACY, VERSION).replace(API_SHARE_MARKETPLACE_VERSION, VERSION))
            .then(response => {
                setMarketplace(response.data);
            })
            .catch(function (error) {
                console.error(error);
            });

        axios.get(userAccountsAPI.defaults.baseURL.replace(API_USER_ACCOUNTS_VERSION, VERSION))
            .then(response => {
                setUserAccounts(response.data);
            })
            .catch(function (error) {
                console.error(error);
            });
    }, []);

    return {
        apartmentSearch,
        bookingGateway,
        consentManagement,
        customerProducts,
        customerDocuments,
        payments,
        marketplace,
        userAccounts,
    };
};
